import { API_ROUTES } from '@ts-auto/shared'
import { companyManifest } from './company'

export const contactApiContract = {
  endpoint: API_ROUTES.contact,
  method: 'POST',
  existingFields: {
    name: { required: true, maxLength: 120 },
    email: { required: true, maxLength: 254, format: 'email' },
    message: { required: true, maxLength: 10_000 },
  },
  response: { success: 'boolean', timestamp: 'ISO-8601' },
} as const

/** Additive proposal: the legacy handler stays valid when these fields are absent. */
export const contactExtensionProposal = {
  phone: {
    required: false,
    maxLength: 32,
    normalize: 'trim; retain leading + and digits; reject other characters',
  },
  privacyAccepted: {
    required: true,
    transport: 'boolean',
    serverRule: 'reject false or missing only after API deployment is coordinated with the form',
  },
  vehicleReference: { required: false, maxLength: 160 },
  compatibility: 'Existing name, email and message requests remain accepted unchanged.',
} as const

/** Contact details verified against https://ts-auto.it/contatti on 2026-09-26. */
export const contactDirectory = {
  office: {
    location: companyManifest.location,
    streetAddress: 'Via Desman, 3',
    postalAddress: '35010 San Giorgio delle Pertiche (PD)',
    mapUrl: 'https://www.google.com/maps?q=TS%20Auto%2C%20Via%20Desman%203%2C%2035010%20San%20Giorgio%20delle%20Pertiche%20PD&output=embed',
    directionsUrl: 'https://www.google.com/maps/dir/?api=1&destination=45.538618,11.9213919',
  },
  phone: ['049 4505915', '388 1055521'],
  email: 'info@ts-auto.it',
} as const
